import React from 'react';
import PropTypes from 'prop-types';
import local from 'services/localization/local';
import { ExternalLink } from 'shared';


// export const iasPrivacyNoticeUrl = "https://calciumhealth.com/ias-privacy-security-notice";
import { iasPrivacyNoticeUrl } from 'app/config';

class IASPrivacySection extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { buttonNameText } = this.props;

        const iasPrivacyLink = (
            <ExternalLink
                href={iasPrivacyNoticeUrl}
                id="ias-privacy-notice"
                logName="ias-privacy-notice-external-url"
                className="nav-ias-privacy"
                openNewTab
            >
                <span>{local.iasPrivacyNotice}</span>
            </ExternalLink>
        );

        const bodyText = local.formatString(
            local.iasPrivacyNoticeText ||
            'This application participates in TEFCA. Please review our {0}.',
            iasPrivacyLink
        );

        return (
            <div className="ias-privacy-link" style={{ marginTop: "10px" }}>
                {bodyText}
            </div>
        );
    }
}

IASPrivacySection.propTypes = {
    buttonNameText: PropTypes.string
};

export default IASPrivacySection;
